module.exports = __webpack_public_path__ + "img/Eagle 2.c74004ac.svg";